import { useMemo } from "react";
import { useLocation } from "react-router-dom";
import { stringToLiteral } from "../helpers/helpers";

export const useQuery = () => {
  const { search } = useLocation();

  return useMemo(() => {
    const queryParams: Record<string, string> = Array.from(new URLSearchParams(search).entries()).reduce((acc, [key, value]) => {
      acc[key] = stringToLiteral(value);
      return acc;
    }, {});

    // Check if token is an array of values and return the first token if needed
    const allTokens = new URLSearchParams(search).getAll('token');
    if (allTokens.length > 0) {
      queryParams.token = allTokens[0]; // Get the first token
    }

    return queryParams;
  }, [search]);
};
